/* John Diven & Co – Orac adhesive calculator (search version, no corners, FDP700 at 75% of Orac's figure) */
(function () {
  var root = document.getElementById('jdgc'); if (!root || !window.JDGC_RATES) return;
  /* factor: FDP700 quantity = Orac's tube count x 0.75, rounded up to a whole tube */
  var GLUES = [
    { sku: 'FDP700', label: 'DecoFix Power FDP700', role: 'Fixing adhesive', ml: 290, idx: 0, factor: 0.75 },
    { sku: 'FX400', label: 'DecoFix Ultra FX400', role: 'Joint adhesive', ml: 270, idx: 1 },
    { sku: 'FL300', label: 'DecoFiller FL300', role: 'Finishing filler', ml: 310, idx: 2 }
  ];
  var ROOMS = { std: 'Standard interior room', damp: 'Damp area', led: 'Indirect lighting / curtain profile', np: 'Non-porous surface', out: 'Outdoor use' };
  var COLLECTION = root.getAttribute('data-collection') || 'collection-vendor-orac-decor';

  var rates = {};
  window.JDGC_RATES.split(';').forEach(function (row) {
    var p = row.split(':'), v = p[1].split(',').map(Number);
    rates[p[0].toUpperCase()] = { meter: v[0] === 1, r: [v[2], v[4], v[6]] };
  });

  var $ = function (id) { return document.getElementById(id); };
  var form = $('jdgc-form'), roomSel = $('jdgc-room'), q = $('jdgc-q'), sugg = $('jdgc-sugg'), qtyIn = $('jdgc-qty');
  var msg = $('jdgc-msg'), list = $('jdgc-list'), empty = $('jdgc-empty'), results = $('jdgc-results');
  var products = {}, index = [], glueProducts = {}, selection = [], chosen = null, matches = [], active = -1;
  try { selection = JSON.parse(sessionStorage.getItem('jdgc2') || '[]'); } catch (e) { selection = []; }

  function money(n) { return '£' + n.toFixed(2); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function save() { try { sessionStorage.setItem('jdgc2', JSON.stringify(selection)); } catch (e) {} }
  function lengthOf(title) { var m = String(title).match(/x\s*(\d+(?:\.\d+)?)\s*m(?![m\w])/i); return m ? parseFloat(m[1]) : null; }
  function clean(t) { return String(t).replace(/^Orac\s+/i, ''); }
  function up(n, size) { return Math.ceil(n / size - 1e-9); }
  function tubesFor(g, ml) { var t = up(ml, g.ml); return g.factor ? Math.max(1, Math.ceil(t * g.factor - 1e-9)) : t; }

  /* ---------- product search ---------- */
  function search(text) {
    var t = text.trim().toLowerCase().replace(/[–-]/g, ' ');
    if (!t) return [];
    var words = t.split(/\s+/).filter(Boolean);
    var out = [];
    index.forEach(function (p) {
      if (!words.every(function (w) { return p.hay.indexOf(w) > -1; })) return;
      var s = p.sku.toLowerCase(), score = 3;
      if (s === words[0]) score = 0; else if (s.indexOf(words[0]) === 0) score = 1; else if (s.indexOf(words[0]) > -1) score = 2;
      out.push({ p: p, score: score });
    });
    out.sort(function (a, b) { return a.score - b.score || a.p.sku.localeCompare(b.p.sku, undefined, { numeric: true }); });
    return out.slice(0, 12).map(function (o) { return o.p; });
  }
  function showSugg() {
    if (!matches.length) {
      sugg.innerHTML = q.value.trim() ? '<li class="jdgc__sugg-none">No matching Orac products – try the product code, e.g. C341</li>' : '';
      sugg.hidden = !q.value.trim(); q.setAttribute('aria-expanded', String(!sugg.hidden)); return;
    }
    sugg.innerHTML = matches.map(function (p, i) {
      return '<li role="option" id="jdgc-opt-' + i + '" class="jdgc__opt' + (i === active ? ' is-active' : '') + '" aria-selected="' + (i === active) + '" data-i="' + i + '">' +
        (p.thumb ? '<img src="' + esc(p.thumb) + '" alt="" width="44" height="44" loading="lazy">' : '<span class="jdgc__opt-ph"></span>') +
        '<span class="jdgc__opt-text"><strong>' + esc(p.sku) + '</strong> ' + esc(clean(p.title).replace(new RegExp('^' + p.sku + '\\s*', 'i'), '')) +
        '<small>' + esc(p.type || '') + '</small></span></li>';
    }).join('');
    sugg.hidden = false; q.setAttribute('aria-expanded', 'true');
    q.setAttribute('aria-activedescendant', active > -1 ? 'jdgc-opt-' + active : '');
  }
  function hideSugg() { sugg.hidden = true; q.setAttribute('aria-expanded', 'false'); active = -1; }
  function choose(p) {
    chosen = p; q.value = clean(p.title); hideSugg(); msg.textContent = '';
    var meter = !rates[p.sku] || rates[p.sku].meter;
    $('jdgc-qty-label').textContent = meter ? 'Metres' : 'Pieces';
    $('jdgc-qty-hint').textContent = meter ? 'Total running metres needed' : 'Number of pieces';
    qtyIn.step = meter ? '0.1' : '1';
    qtyIn.focus();
  }
  q.addEventListener('input', function () { chosen = null; active = -1; matches = search(q.value); showSugg(); });
  q.addEventListener('focus', function () { if (!chosen && q.value.trim()) { matches = search(q.value); showSugg(); } });
  q.addEventListener('keydown', function (e) {
    if (sugg.hidden && (e.key === 'ArrowDown') && q.value.trim()) { matches = search(q.value); showSugg(); }
    if (e.key === 'ArrowDown' && matches.length) { e.preventDefault(); active = (active + 1) % matches.length; showSugg(); }
    else if (e.key === 'ArrowUp' && matches.length) { e.preventDefault(); active = active <= 0 ? matches.length - 1 : active - 1; showSugg(); }
    else if (e.key === 'Enter' && !sugg.hidden && matches.length) { e.preventDefault(); choose(matches[active > -1 ? active : 0]); }
    else if (e.key === 'Escape') { hideSugg(); }
  });
  sugg.addEventListener('mousedown', function (e) { var li = e.target.closest('.jdgc__opt'); if (!li) return; e.preventDefault(); choose(matches[+li.getAttribute('data-i')]); });
  document.addEventListener('click', function (e) { if (!e.target.closest('.jdgc__search')) hideSugg(); });

  /* ---------- calculation ---------- */
  function needs(item) {
    var r = rates[item.sku]; if (!r) return [0, 0, 0];
    return r.r.map(function (perUnit, i) { return (i === 2 && (item.room === 'damp' || item.room === 'out')) ? 0 : perUnit * item.qty; });
  }

  function render() {
    empty.style.display = selection.length ? 'none' : '';
    list.innerHTML = selection.map(function (it, i) {
      var p = products[it.sku] || { title: it.sku, url: '#' }; var r = rates[it.sku] || { meter: true };
      var unit = r.meter ? (it.qty + ' m') : (it.qty + (it.qty === 1 ? ' piece' : ' pieces'));
      var len = r.meter ? lengthOf(p.title) : null;
      var lengths = len ? ' · ' + up(it.qty, len) + ' × ' + len + 'm lengths' : '';
      return '<li class="jdgc__item"><div class="jdgc__item-name"><a href="' + esc(p.url) + '">' + esc(clean(p.title)) + '</a></div>' +
        '<button type="button" class="jdgc__remove" data-i="' + i + '" aria-label="Remove ' + esc(it.sku) + '">Remove</button>' +
        '<div class="jdgc__item-meta">' + esc(ROOMS[it.room] || '') + ' · ' + unit + lengths + '</div></li>';
    }).join('');

    if (!selection.length) { results.innerHTML = '<p class="jdgc__empty jdgc__empty--dark">Your adhesive list will appear here.</p>'; return; }
    var tot = [0, 0, 0];
    selection.forEach(function (it) { var n = needs(it); tot[0] += n[0]; tot[1] += n[1]; tot[2] += n[2]; });
    var grand = 0, html = '';
    GLUES.forEach(function (g) {
      var ml = tot[g.idx]; if (ml <= 0) return;
      var t = tubesFor(g, ml); var gp = glueProducts[g.sku];
      if (gp) grand += gp.price * t;
      html += '<div class="jdgc__glue">' + (gp && gp.image ? '<img src="' + esc(gp.image) + '" alt="" loading="lazy" width="56" height="56">' : '<span></span>') +
        '<div><div class="jdgc__glue-name">' + (gp ? '<a href="' + esc(gp.url) + '">' + g.label + '</a>' : g.label) + '</div>' +
        '<div class="jdgc__glue-sub">' + g.role + ' · ' + g.ml + 'ml tube' + (gp ? ' · ' + money(gp.price) + ' each' : '') + '</div></div>' +
        '<div class="jdgc__glue-qty">' + t + '<small>' + (t === 1 ? 'tube' : 'tubes') + '</small></div></div>';
    });
    var mouldings = selection.map(function (it) {
      var p = products[it.sku], r = rates[it.sku]; if (!p || !r) return null;
      var len = lengthOf(p.title);
      var qn = r.meter ? (len ? up(it.qty, len) : null) : Math.ceil(it.qty);
      return qn ? { id: p.variant, quantity: qn } : null;
    }).filter(Boolean);
    html += '<div class="jdgc__total"><span>Adhesives total</span><strong>' + money(grand) + '</strong></div><p class="jdgc__vat">Prices exclude VAT</p>';
    if (mouldings.length) html += '<label class="jdgc__check"><input type="checkbox" id="jdgc-incl"> Also add my mouldings to the basket (full lengths / pieces, as listed in your selection)</label>';
    html += '<button type="button" class="jdgc__btn jdgc__btn--stone jdgc__btn--full" id="jdgc-cart">Add adhesives to basket</button><p class="jdgc__ok" id="jdgc-ok" role="status"></p>';
    results.innerHTML = html;
    $('jdgc-cart').addEventListener('click', function () {
      var items = [];
      GLUES.forEach(function (g) { var ml = tot[g.idx], gp = glueProducts[g.sku]; if (ml > 0 && gp) items.push({ id: gp.variant, quantity: tubesFor(g, ml) }); });
      var incl = $('jdgc-incl'); if (incl && incl.checked) items = items.concat(mouldings);
      if (!items.length) return;
      var btn = this; btn.disabled = true; btn.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () { $('jdgc-ok').innerHTML = 'Added to your basket. <a href="/cart">View basket</a>'; btn.textContent = 'Added ✓'; document.dispatchEvent(new CustomEvent('cart:refresh')); })
        .catch(function () { $('jdgc-ok').textContent = 'Sorry, something went wrong. Please try again.'; btn.disabled = false; btn.textContent = 'Add adhesives to basket'; });
    });
  }

  list.addEventListener('click', function (e) {
    var b = e.target.closest('.jdgc__remove'); if (!b) return;
    selection.splice(+b.getAttribute('data-i'), 1); save(); render();
  });
  form.addEventListener('submit', function (e) {
    e.preventDefault(); msg.textContent = '';
    if (!chosen && q.value.trim()) { var m = search(q.value); if (m.length === 1) choose(m[0]); }
    if (!chosen) { msg.textContent = 'Please search for a product and pick it from the list.'; q.focus(); return; }
    var r = rates[chosen.sku];
    var qty = parseFloat(String(qtyIn.value).replace(',', '.'));
    if (!(qty > 0)) { msg.textContent = 'Please enter how many ' + (r && !r.meter ? 'pieces' : 'metres') + ' you need.'; qtyIn.focus(); return; }
    var room = roomSel.value;
    var existing = selection.filter(function (it) { return it.sku === chosen.sku && it.room === room; })[0];
    if (existing) existing.qty = Math.round((existing.qty + qty) * 100) / 100;
    else selection.push({ sku: chosen.sku, room: room, qty: Math.round(qty * 100) / 100 });
    save(); render(); qtyIn.value = ''; q.value = ''; chosen = null; q.focus();
  });

  /* ---------- load products ---------- */
  function loadAll() {
    var all = [];
    function next(p) {
      return fetch('/collections/' + COLLECTION + '/products.json?limit=250&page=' + p)
        .then(function (r) { return r.json(); })
        .then(function (d) { var items = d.products || []; all = all.concat(items); return items.length === 250 && p < 6 ? next(p + 1) : all; });
    }
    return next(1);
  }
  loadAll().then(function (all) {
    all.forEach(function (p) {
      var v = p.variants && p.variants[0]; if (!v || !v.sku) return;
      var sku = String(v.sku).split('|')[0].trim().toUpperCase();
      var img = p.images && p.images[0] ? p.images[0].src : '';
      var sep = img.indexOf('?') > -1 ? '&' : '?';
      var item = { sku: sku, title: p.title, url: '/products/' + p.handle, type: p.product_type, variant: v.id, price: parseFloat(v.price),
        image: img ? img + sep + 'width=160' : '', thumb: img ? img + sep + 'width=88' : '' };
      if (GLUES.some(function (g) { return g.sku === sku; })) { glueProducts[sku] = item; return; }
      if (rates[sku] && !products[sku]) {
        item.hay = (sku + ' ' + clean(p.title) + ' ' + (p.product_type || '')).toLowerCase().replace(/[–-]/g, ' ');
        products[sku] = item; index.push(item);
      }
    });
    selection = selection.filter(function (it) { return rates[it.sku]; });
    q.disabled = false; q.placeholder = 'Type a product code or name, e.g. C341 or skirting';
    var pre = new URLSearchParams(location.search).get('sku');
    if (pre && products[pre.toUpperCase()]) choose(products[pre.toUpperCase()]);
    render();
  }).catch(function () { q.placeholder = 'Sorry, products could not be loaded – please refresh'; });
})();